import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import ThanksStepView from '../../../components/views/mx/creditoReal/ThanksStepView';
import * as WizardMXActions from '../../../actions/WizardMXActions';

const mapStateToProps = state => ({

});

const mapDispatchToProps = (dispatch) => {
    return {
        onPressContinue: () => {
            dispatch(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.action());
            dispatch(WizardMXActions.GO_TO_TURBO_CASH_ACTION.action());
        },
    };
};

const ThanksStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps
)(ThanksStepView));

export default ThanksStepContainer;